import React, { useState, useEffect } from 'react';

import { SpecialsBanner } from '../SpecialsBanner/SpecialsBanner';
import { OnSaleBanner } from '../OnSaleBanner/OnSaleBanner';

import './BannerRotator.scss';

const ROTATE_INTERVAL = 5000;

export const BannerRotator = () => {
  const [showSpecials, setShowSpecials] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowSpecials(prev => !prev);
    }, ROTATE_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mp-banner-rotator">
      <div className={`mp-banner-rotator-slide ${showSpecials ? 'active' : ''}`}>
        <SpecialsBanner />
      </div>
      <div className={`mp-banner-rotator-slide ${showSpecials ? '' : 'active'}`}>
        <OnSaleBanner />
      </div>
    </div>
  );
};
